module.exports = __webpack_public_path__ + "media/KZ-ZAP.96d55de1.ogg";